"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _spacingMixin = require("../../mixins/spacingMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
/**
 * Generic component for applying spacing props around its children.
 *
 * All spacing props support inline media query objects.
 *
 * @since 5.0.0
 */
var Spacer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Spacer",
  componentId: "c11n-8-107-0__sc-17suqs2-0"
})(["", ""], _spacingMixin.spacingMixin);
exports.Spacer = Spacer;
Spacer.displayName = 'Spacer';
Spacer.propTypes = {
  /**
   * Adds CSS padding based on spacing token values
   */
  padding: _customPropTypes.default.spacing,
  /**
   * Adds CSS padding-left and padding-right based on spacing token values
   */
  paddingX: _customPropTypes.default.spacing,
  /**
   * Adds CSS padding-top and padding-bottom based on spacing token values
   */
  paddingY: _customPropTypes.default.spacing,
  /**
   * Adds CSS padding-top based on spacing token values
   */
  paddingTop: _customPropTypes.default.spacing,
  /**
   * Adds CSS padding-bottom based on spacing token values
   */
  paddingBottom: _customPropTypes.default.spacing,
  /**
   * Adds CSS padding-right based on spacing token values
   */
  paddingRight: _customPropTypes.default.spacing,
  /**
   * Adds CSS padding-left based on spacing token values
   */
  paddingLeft: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin based on spacing token values
   */
  margin: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin-left and margin-right based on spacing token values
   */
  marginX: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin-top and margin-bottom based on spacing token values
   */
  marginY: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin-top based on spacing token values
   */
  marginTop: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin-bottom based on spacing token values
   */
  marginBottom: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin-right based on spacing token values
   */
  marginRight: _customPropTypes.default.spacing,
  /**
   * Adds CSS margin-left based on spacing token values
   */
  marginLeft: _customPropTypes.default.spacing
};

/** @component */